<template>
  <div class="nkn-client-intro">
    <div class="common-title">{{$t("developer.title")}}</div>
    <div class="common-sub-title">{{$t("developer.clientIntro.title")}}</div>
    <div class="nkn-video">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-6 video-col">
          <div class="nkn-video-intro">
            <div class="nkn-video-title">{{$t("developer.clientIntro.vtitle1")}}</div>
            <video-player class="nkn-video-body client-intro-flag"  height="350" :options="introOptions"
                          :playsinline="true"></video-player>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 video-col">
          <div class="nkn-video-disc">
            <div class="nkn-video-title">{{$t("developer.clientIntro.vtitle2")}}</div>
            <video-player v-if="lang === 'zh'" class="nkn-video-body client-intro-flag" :options="sdkOptions"
                          :trackList="[
            {id: 'my-spanish-audio-track', kind: 'subtitles', label: '中文字幕', language: 'zh', srclang: 'zh', src: '/static/video/nkn-sdk.vtt', default: true }
            ]"
                          :playsinline="true">
            </video-player>
            <video-player v-else class="nkn-video-body client-intro-flag" :options="sdkOptions"
                          :playsinline="true">
            </video-player>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .video-js.vjs-fluid, .video-js.vjs-16-9, .video-js.vjs-4-3{height: 350px;}
</style>
<script>
  import 'video.js/dist/video-js.css'
  import {videoPlayer} from 'vue-video-player'
  import {
    mapState
  } from 'vuex'
  import videoMix from '@/assets/js/nknVideoMix.js'


  export default {
    components: {
      videoPlayer
    },
    mixins: [videoMix],
    computed: {
      ...mapState({
        lang: state => state.lang.lang
      })
    },
    data: function () {
      return {
        introOptions: {
          autoplay: false,
          muted: false,
          fluid: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: this.$url.VIDEOLINKEN.nknIntro
          }],
          poster: '/static/img/developer/video/NKNintro.png'
        },
        sdkOptions: {
          autoplay: false,
          muted: false,
          fluid: true,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          preload: 'none',
          sources: [{
            type: 'video/mp4',
            src: this.$url.VIDEOLINKEN.nknSDK
          }],
          poster: '/static/img/developer/video/NKNSDK.png'
        }
      }
    },
    watch: {
      lang: function () {
        if (this.$i18n.locale === 'zh'){
          this.introOptions.poster = '/static/img/developer/video/NKN-tech-intro-Yilun_Chinese.png'
          this.sdkOptions.poster = '/static/img/developer/video/NKN-SDK-Chinese.png'
        }else{
          this.introOptions.poster = '/static/img/developer/video/NKNintro.png'
          this.sdkOptions.poster = '/static/img/developer/video/NKNSDK.png'
        }
        this.videoSet(this.introOptions, 'nknIntro')
        this.videoSet(this.sdkOptions, 'nknSDK')
      }
    },
    mounted() {
      if (this.$i18n.locale === 'zh'){
        this.introOptions.poster = '/static/img/developer/video/NKN-tech-intro-Yilun_Chinese.png'
        this.sdkOptions.poster = '/static/img/developer/video/NKN-SDK-Chinese.png'
      }else{
        this.introOptions.poster = '/static/img/developer/video/NKNintro.png'
        this.sdkOptions.poster = '/static/img/developer/video/NKNSDK.png'
      }
      this.videoSet(this.introOptions, 'nknIntro')
      this.videoSet(this.sdkOptions, 'nknSDK')
    }
  }
</script>

<style lang="scss" scoped>

  .nkn-client-intro {
    .common-sub-title {
      @media screen and (max-width: 768px) {
        text-align: left;
        padding-left: 15px;
      }
    }

    @include common-inner();

    .video-col {
      padding-left: 0;
    }

    .nkn-video {
      padding: 2rem 0;
      @media screen and (max-width: 768px) {
        padding-left: 15px;
      }

      &-title {
        @include nkn-font-set(.9rem, $common-color);
        line-height: 1;
        @media screen and (max-width: 768px) {
          padding-left: 0;
          margin-bottom: 4px;
        }
      }

      &-body {
        margin-top: 1rem;
        width: 560px;
        height: 331px;

        @media screen and (max-width: 768px) {
          width: 100%;
          height: auto;
          margin: 0 auto;
          margin-top: 0;
          margin-bottom: 20px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/developer/nknClientIntro.vue